import { createSelector } from '@reduxjs/toolkit';
import { CurrencyItem } from '../../types';
import { ConfigurationRootState } from '../../../../store/state';

const filteredCurrencies = (currencies: CurrencyItem[], searchText: string) => {
  const nextCurrencies = currencies?.filter(
    (item) =>
      item?.description?.toLowerCase().includes(searchText?.toLowerCase()) ||
      item?.code.toString().includes(searchText) ||
      item?.name.toLowerCase().includes(searchText?.toLowerCase()),
  );

  return nextCurrencies;
};

const documentsSource = (state: ConfigurationRootState) =>
  state.currencies.list;

const currencies = createSelector(documentsSource, (state) => {
  const { values, searchText } = state;

  const nextCurrencies = filteredCurrencies(
    values as CurrencyItem[],
    searchText,
  );

  return nextCurrencies;
});

export default currencies;
